import memoize from 'memoize-one';

export default memoize(getDurations);

function getDurations(content) {
  const children = {};
  let total = content.data.activity_metadata?.duration || 0;
  if (content.children) {
    content.children.forEach(c => {
      const childResult = getDurations(c);
      total += childResult.total;
      children[c.key] = childResult;
    });
  }
  return { total, children };
}
